// extracted by mini-css-extract-plugin
module.exports = {"root":"Rules_root__3otPK","players":"Rules_players__1e7kQ","stonesGrid":"Rules_stonesGrid__2rwYr","tilesGrid":"Rules_tilesGrid__b4vlY"};